var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentOptionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 27,
    viewBox: "0 0 40 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 22.4683C0.666992 23.5864 1.17402 24.6587 2.07654 25.4492C2.97906 26.2398 4.20314 26.684 5.47949 26.684H34.3545C35.6308 26.684 36.8549 26.2398 37.7574 25.4492C38.66 24.6587 39.167 23.5864 39.167 22.4683V10.8753H0.666992V22.4683ZM6.33887 16.7471C6.33887 16.1481 6.61049 15.5737 7.09398 15.1502C7.57747 14.7266 8.23323 14.4887 8.91699 14.4887H13.042C13.7258 14.4887 14.3815 14.7266 14.865 15.1502C15.3485 15.5737 15.6201 16.1481 15.6201 16.7471V18.2527C15.6201 18.8516 15.3485 19.4261 14.865 19.8496C14.3815 20.2731 13.7258 20.5111 13.042 20.5111H8.91699C8.23323 20.5111 7.57747 20.2731 7.09398 19.8496C6.61049 19.4261 6.33887 18.8516 6.33887 18.2527V16.7471ZM34.3545 0.185547H5.47949C4.20314 0.185547 2.97906 0.629696 2.07654 1.42029C1.17402 2.21088 0.666992 3.28314 0.666992 4.40121V6.35848H39.167V4.40121C39.167 3.28314 38.66 2.21088 37.7574 1.42029C36.8549 0.629696 35.6308 0.185547 34.3545 0.185547Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentOptionLogo);
export default __webpack_public_path__ + "static/media/payment_option_logo.c6d234614d366f3e43e3820efadbe217.svg";
export { ForwardRef as ReactComponent };